// extracted by mini-css-extract-plugin
export default {"sticker":"styles_sticker__wnJCZ","empty":"styles_empty__kMfyA","empty__text":"styles_empty__text__pA8ft","empty__blur":"styles_empty__blur__avDkl"};